module.exports = __webpack_public_path__ + "media/images/athletes/1836-aca4c337678c05af63fb955dbf6674e3.png";